export const company = {
  brand: "M.F.D. & Co.",
  legalName: "M.F.D. Dienstleistungs GmbH & Co. KG",
  street: "Großbeerenstraße 2-10",
  postalCode: "12107",
  city: "Berlin",
  email: "mfdienstleistungen@hotmail.com",
  inquiryEmail: "service@mfd-berlin.com",
  phones: [
    { display: "+49 151 431 48300", tel: "+4915143148300" },
    { display: "+49 170 504 6545", tel: "+491705046545" },
  ],
  lat: 52.439074,
  lng: 13.3786568,
  registerCourt: "Amtsgericht Charlottenburg",
  registerNumber: "HRA 54088 B",
  partnerName: "M.F.D. GmbH",
  partnerRegister: "HRB 189578 B",
  directorName: "Monika Ch. A. Faki",
  hoursLabel: "Montag bis Freitag, 6:00–18:00 Uhr",
};
